jQuery($ => {
    class ProductThumbnailCard {
        constructor(element) {
            this._                  = element;
            this._element           = $(element);
            this._swatch            = this._element.find('.m-product-thumbnail-card__swatch');
            this._swatchImage       = this._element.find('.m-product-thumbnail-card__swatch-image');
            this._swatchPrice       = this._element.find('.m-product-thumbnail-card__swatch-price');
            this._swatchButton      = this._element.find('.m-product-thumbnail-card__swatch-button');
            this._ajaxButton        = this._element.find('.ajax-add-to-cart');
            this._productID         = this._ajaxButton.data('product_id');
            this._productCard       = this._ajaxButton.closest('.m-product-thumbnail-card');
            this._productCardFooter = this._ajaxButton.closest('.m-product-thumbnail-card__footer');
            this._message           = this._productCard.find('.m-product-thumbnail-card__message');

            this.init();
        }
 
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger( 'init', this );
        }  

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
 
        setupHandlers() {
            this._swatch.on('click', (e) => {
                this.handleSwatchClick(e);
            }); 
 
            this._ajaxButton.on('click', (e) => {
                e.preventDefault();

                this.handleAddtoCart(this._productID);
            });
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Swatch Click
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleSwatchClick = (e) => {
            var clickedSwatch = $(e.currentTarget),
                index         = clickedSwatch.index(),
                newProductID  = clickedSwatch.data('product_id');

            // Get the product ID associated with the clicked swatch
            if (newProductID) {
                this._productID = newProductID; // Update the product ID

                this._ajaxButton.data('product_id', newProductID); // Sync button data
            }

            // Remove active class from all swatches
            this._swatch.removeClass('m-product-thumbnail-card__swatch--active');
            this._swatchImage.removeClass('m-product-thumbnail-card__swatch-image--active');
            this._swatchButton.removeClass('m-product-thumbnail-card__swatch-button--active');
            this._swatchPrice.removeClass('m-product-thumbnail-card__swatch-price--active');

            // Add active class to the clicked swatch
            clickedSwatch.addClass('m-product-thumbnail-card__swatch--active');
            this._swatchImage.eq(index).addClass('m-product-thumbnail-card__swatch-image--active');
            this._swatchButton.eq(index).addClass('m-product-thumbnail-card__swatch-button--active');
            this._swatchPrice.eq(index).addClass('m-product-thumbnail-card__swatch-price--active');
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Add to Cart
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleAddtoCart = (productID) => {
            $.ajax({
                type: 'POST',
                url: AJAX.url,
                data: {
                    action: 'add_to_cart',
                    product_id: productID,
                },
                beforeSend: () => {
                    this._productCard.addClass('ajax-loading');

                    $('.o-header__cart-ajax-wrapper').addClass('ajax-loading');
                },
                success: (result) => {
                    if (result.data.message) {
                        // Remove any existing message before appending a new one
                        this._productCard.find('.m-product-thumbnail-card__message').remove();

                        if (this._productCard.hasClass('m-product-thumbnail-card--has-simple-button')) {
                            this._productCardFooter.append(result.data.message);
                        } else {
                            this._productCard.append(result.data.message);
                        }

                        // Remove the loading class
                        this._productCard.removeClass('ajax-loading');
                        $('.o-header__cart-ajax-wrapper').removeClass('ajax-loading');

                        // Trigger custom event after the AJAX success
                        $(window).trigger('ajax');
                    }

                    if (result.data.mini_cart_trigger) {
                        $('.o-header__cart-ajax-wrapper').html(result.data.mini_cart_trigger);

                        $(window).trigger('ajax');

                        $('.o-header__cart-ajax-wrapper').removeClass('ajax-loading');

                        $('.m-drawer-trigger').drawer_trigger();

                        $('.m-drawer').drawer();
                        $('.m-drawer').drawer('handleOpen');

                        $('.m-mini-cart').mini_cart();
 
                        $('.m-cart-card').cart_card(); 

                        $('.m-product-thumbnail-card').product_thumbnail_card();
                        $('.m-product-thumbnail-cards--slider').product_thumbnail_cards_slider();
                    } 
                },
                error: () => {
                    $('.o-header__cart-ajax-wrapper').removeClass('ajax-loading');
                    this._productCard.removeClass('ajax-loading');
                    alert('Failed to add product to cart.');
                }
            });
        }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.product_thumbnail_card = function() {
        var _ = this,
                opt = arguments[0],
                args = Array.prototype.slice.call(arguments, 1),
                l = _.length,
                i,
                ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].product_thumbnail_card = new ProductThumbnailCard(_[i], opt);
            else
                ret = _[i].product_thumbnail_card[opt].apply(_[i].product_thumbnail_card, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.m-product-thumbnail-card').product_thumbnail_card();
});